import React, { useEffect, useState } from "react";
import { getOrders } from "../services/ipeOrderService";
import { approveOrder } from "../services/ipeOrderService";
import IPEOrderCreateDrawer from "../components/IPEOrderCreateDrawer";
import IPEOrderViewDrawer from "../components/IPEOrderViewDrawer";
const ITEMS_PER_PAGE = 5;

const IPEOrderListPage = () => {
  const [orders, setOrders] = useState([]);
  const [showDrawer, setShowDrawer] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [editOrderId, setEditOrderId] = useState(null);
  const [filters, setFilters] = useState({
    search: "",
    status: "",
    from_date: "",
    to_date: ""
  });

  useEffect(() => {
    loadOrders();
  }, []);

  const loadOrders = async (customFilters = filters) => {
    try {
      console.log("Sending filters:", customFilters); // 🔥 DEBUG

      const res = await getOrders(customFilters);

      setOrders(res.data.data.items || []);
    } catch (err) {
      console.error(err);
    }
  };
  const handleApprove = async (orderId) => {
  const ok = window.confirm("Are you sure you want to confirm this order?");
  if (!ok) return;

  try {
    await approveOrder(orderId);

    alert("Order confirmed successfully");

    loadOrders(); // 🔥 refresh list
  } catch (e) {
    alert(e.response?.data?.message || "Failed to confirm order");
  }
};

  // 🔷 Helpers
  const formatCurrency = (value) => {
    if (!value) return "₹ 0";
    return "₹ " + Number(value).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
    });
  };

  const getStatusBadge = (status) => {
    const baseStyle = {
      padding: "4px 10px",
      borderRadius: 20,
      fontSize: 12,
      fontWeight: 600,
    };

    switch (status) {
      case "DRAFT":
        return <span style={{ ...baseStyle, background: "#fef3c7" }}>Draft</span>;
      case "CONFIRMED":
        return <span style={{ ...baseStyle, background: "#d1fae5" }}>Confirmed</span>;
      case "CANCELLED":
        return <span style={{ ...baseStyle, background: "#fee2e2" }}>Cancelled</span>;
      default:
        return <span>{status}</span>;
    }
  };

  // 🔷 Summary
  const totalOrders = orders.length;
  const draftCount = orders.filter((o) => o.status_code === "DRAFT").length;
  const confirmedCount = orders.filter((o) => o.status_code === "CONFIRMED").length;
  const totalValue = orders.reduce((sum, o) => sum + (o.total_amount || 0), 0);

  const [viewOrderId, setViewOrderId] = useState(null);
  const [showView, setShowView] = useState(false);  
  
  // 🔷 Pagination
  const totalPages = Math.ceil(orders.length / ITEMS_PER_PAGE);

  const paginatedOrders = orders.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  return (
    <div style={{ padding: 20 }}>

      {/* 🟣 HEADER (LIKE ENQUIRY) */}
      <div
        style={{
          background: "linear-gradient(90deg, #6d28d9, #4f46e5)",
          color: "#fff",
          padding: 20,
          borderRadius: 12,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>
          <h2 style={{ margin: 0 }}>IPE Orders</h2>
          <div style={{ fontSize: 13, opacity: 0.9 }}>
            Manage and track customer orders
          </div>
        </div>

        <button
          onClick={() => setShowDrawer(true)}
          style={{
            background: "#fff",
            color: "#4f46e5",
            padding: "8px 14px",
            borderRadius: 6,
            border: "none",
            cursor: "pointer",
            fontWeight: 600,
          }}
        >
          + Create Order
        </button>
      </div>

      {/* 🔷 KPI CARDS (UNCHANGED STRUCTURE, IMPROVED STYLE) */}
      <div style={{ display: "flex", gap: 16, marginTop: 20 }}>
        <Card title="TOTAL ORDERS" value={totalOrders} color="#4f46e5" icon="📦" />
        <Card title="DRAFT" value={draftCount} color="#f59e0b" icon="📝" />
        <Card title="CONFIRMED" value={confirmedCount} color="#10b981" icon="✔" />
        <Card title="TOTAL VALUE" value={formatCurrency(totalValue)} color="#2563eb" icon="💰" />
      </div>

      {/* 🔷 FILTER BAR (UNCHANGED) */}
      <div
        style={{
          marginTop: 20,
          padding: 12,
          borderRadius: 10,
          background: "#fff",
          boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
          display: "flex",
          gap: 10,
          flexWrap: "wrap",
          alignItems: "center"
        }}
      >
        <input
          placeholder="Search Order No / Customer"
          style={inputStyle}
          value={filters.search}
          onChange={(e) =>
            setFilters({ ...filters, search: e.target.value })
          }
        />

        <select
          style={inputStyle}
          value={filters.status}
          onChange={(e) =>
            setFilters({ ...filters, status: e.target.value })
          }
        >
          <option value="">All Status</option>
          <option value="DRAFT">DRAFT</option>
          <option value="CONFIRMED">CONFIRMED</option>
          <option value="CANCELLED">CANCELLED</option>
        </select>

        <input type="date" style={inputStyle} />
        <input type="date" style={inputStyle} />

        <button style={applyBtn} onClick={() => loadOrders()}>
          Apply
        </button>
        <button style={resetBtn}>Reset</button>
      </div>

      {/* 🔷 TABLE (ONLY EXTENDED, NOT MODIFIED) */}
      <div style={{ marginTop: 20 }}>
        <table
          width="100%"
          style={{
            borderCollapse: "separate",
            borderSpacing: "0 10px",
            fontSize: 14,
          }}
        >
          <thead>
            <tr style={{ textAlign: "left", color: "#666" }}>
              <th>Order No</th>
              <th>Customer</th>
              <th>Enquiry</th>
              <th>Quotation</th>
              <th>Items</th>
              <th>Total</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {paginatedOrders.map((o) => (
              <tr
                key={o.id}
                style={{
                  background: "#fff",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                  borderRadius: 8,
                }}
              >
                <td style={td}>{o.order_no}</td>
                <td style={td}>{o.customer_name || "-"}</td>
                <td style={td}>{o.enquiry_no || "-"}</td>
                <td style={td}>{o.quotation_no || "-"}</td>
                <td style={td}>{o.item_count || "-"}</td>
                <td style={td}>{formatCurrency(o.total_amount)}</td>
                <td style={td}>{getStatusBadge(o.status_code)}</td>
                <td style={td}>
                  <button
                    style={btn}
                    onClick={() => {
                      setViewOrderId(o.id);
                      setShowView(true);
                    }}
                  >
                    View
                  </button>
                  {o.status_code === "DRAFT" && (
                    <>
                      <button
                        style={btn}
                        onClick={() => {
                          setEditOrderId(o.id);
                          setShowDrawer(true);
                        }}
                      >
                        Edit
                      </button>
                      <button
                        style={confirmBtn}
                        onClick={() => handleApprove(o.id)}
                      >
                        Approve
                      </button>
                    </>
                  )}
                </td>
              </tr>
            ))}

            {orders.length === 0 && (
              <tr>
                <td colSpan="8" style={{ textAlign: "center", padding: 20 }}>
                  No orders found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* 🔷 PAGINATION (UNCHANGED) */}
      {totalPages > 1 && (
        <div
          style={{
            marginTop: 20,
            display: "flex",
            justifyContent: "center",
            gap: 10,
          }}
        >
          <button
            onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
            disabled={currentPage === 1}
          >
            Prev
          </button>

          <span>
            Page {currentPage} / {totalPages}
          </span>

          <button
            onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      )}

      {/* 🔷 DRAWER (UNCHANGED) */}
      {showDrawer && (
        <IPEOrderCreateDrawer
          key={editOrderId || "new"}   // 🔥 CRITICAL FIX
          orderId={editOrderId}
          drawerMode={editOrderId ? "edit" : "create"}
          onClose={() => {
            setShowDrawer(false);
            setEditOrderId(null);
          }}
          onSuccess={loadOrders}
        />
      )}
      {/* 🔷 VIEW DRAWER */}
      {showView && (
        <IPEOrderViewDrawer
          orderId={viewOrderId}
          onClose={() => setShowView(false)}
        />
      )}
    </div>
  );
};

// 🔷 KPI CARD (UPDATED STYLE ONLY)
const Card = ({ title, value, color = "#4f46e5", icon }) => (
  <div
    style={{
      flex: 1,
      display: "flex",
      alignItems: "center",
      gap: 12,
      padding: 14,
      background: "#fff",
      borderRadius: 10,
      boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
      borderLeft: `4px solid ${color}`,
    }}
  >
    <div
      style={{
        width: 36,
        height: 36,
        borderRadius: 8,
        background: "#f3f4f6",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 18,
      }}
    >
      {icon}
    </div>

    <div>
      <div style={{ fontSize: 11, color: "#6b7280", fontWeight: 500 }}>
        {title}
      </div>
      <div style={{ fontSize: 18, fontWeight: "bold" }}>
        {value}
      </div>
    </div>
  </div>
);

// 🔷 Styles (UNCHANGED)
const td = { padding: 12 };

const btn = {
  marginRight: 8,
  padding: "4px 10px",
  border: "1px solid #ccc",
  background: "#fff",
  cursor: "pointer",
};

const confirmBtn = {
  padding: "4px 10px",
  border: "none",
  background: "#10b981",
  color: "#fff",
  cursor: "pointer",
};

const inputStyle = {
  padding: "8px 10px",
  borderRadius: 6,
  border: "1px solid #ccc",
  minWidth: 160,
};

const applyBtn = {
  padding: "8px 14px",
  background: "#2563eb",
  color: "#fff",
  border: "none",
  borderRadius: 6,
  cursor: "pointer",
};

const resetBtn = {
  padding: "8px 14px",
  background: "#e5e7eb",
  border: "none",
  borderRadius: 6,
  cursor: "pointer",
};

export default IPEOrderListPage;